import React from 'react';
import { Box, Card, Typography, Avatar, Button, Chip, Fade, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import StarIcon from '@mui/icons-material/Star';
import { urlImg, isEmpty } from '../../common/helpers';

const ProfileProviderCard = ({ profile }) => {
  const navigate = useNavigate();

  const { user, userData, perfil, serviceCount, activeServices } = profile;
  const userName = userData?.name || 'Proveedor';

  // Calificación del proveedor = promedio ponderado de sus servicios (por nº de reseñas)
  const serviciosCalificados = (activeServices || []).filter(s => s.ratingPromedio > 0 && s.ratingTotal > 0);
  const totalResenas = serviciosCalificados.reduce((acc, s) => acc + s.ratingTotal, 0);
  const ratingProveedor = totalResenas > 0
    ? serviciosCalificados.reduce((acc, s) => acc + s.ratingPromedio * s.ratingTotal, 0) / totalResenas
    : 0;
  const role = perfil?.rol || 'Experto';
  let avatarUrl = '/search.png';
  if (!isEmpty(userData?.avatar)) {
    const avatarStr = userData.avatar.toString();
    if (avatarStr.startsWith("http")) {
      avatarUrl = avatarStr;
    } else if (avatarStr.startsWith("//")) {
      avatarUrl = avatarStr.replace(/^\/\//, "https://");
    } else {
      avatarUrl = `${urlImg}/w_150,h_150,c_fill/users/${user}/${userData.avatar}`;
    }
  }

  const serviceText = serviceCount === 1 ? 'servicio realizado' : 'servicios realizados';

  const handleViewProfile = () => {
    window.location.href = `/perfil/${user}`; // Force true navigation if we want to reset scroll, or use navigate
  };

  return (
    <Card
      elevation={0}
      sx={{
        minWidth: 260,
        maxWidth: 260,
        borderRadius: '8px',
        border: '1px solid #EAEAEA',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
        transition: 'transform 0.2sease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 16px rgba(0,0,0,0.08)'
        }
      }}
    >
      {/* Header section */}
      <Grid container
        sx={{
          height: 95,
          background: 'linear-gradient(135deg, #D6A4B4 0%, #C4879B 100%)',
          position: 'relative',
          p: 1.5,
          pt: 2
        }}
      >
        <Grid container alignItems="center" sx={{ gap: 0.5, color: 'white' }}>
          <VerifiedUserIcon sx={{ fontSize: 13 }} />
          <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '11px' }}>Verificado</Typography>
        </Grid>

        <Avatar
          src={avatarUrl}
          sx={{
            width: 56,
            height: 56,
            position: 'absolute',
            bottom: -28,
            left: 16,
            border: '3px solid white',
            bgcolor: 'white'
          }}
        />
      </Grid>

      {/* Content section */}
      <Grid container direction="column" sx={{ p: 2, pt: 4, flex: 1 }}>
        <Grid container justifyContent="space-between" alignItems="flex-start" sx={{ mb: 0.5 }}>
          <Typography variant="subtitle2" fontWeight="bold" color="#0E2465" sx={{ fontSize: '14px', lineHeight: 1.2 }}>
            {userName}
          </Typography>
          <Grid container alignItems="center" sx={{ width: 'auto', gap: 0.5 }}>
            {ratingProveedor > 0 ? (
              <>
                <StarIcon sx={{ fontSize: 13, color: '#0E2465' }} />
                <Typography variant="caption" fontWeight="bold" color="#1A1A1A" sx={{ fontSize: "11px" }}>
                  {ratingProveedor.toFixed(1)}
                </Typography>
              </>
            ) : (
              <Typography variant="caption" fontWeight="bold" color="#94A3B8" sx={{ fontSize: "11px" }}>
                Nuevo
              </Typography>
            )}
          </Grid>
        </Grid>

        <Typography variant="caption" color="#737791" display="block" sx={{ mb: 2 }}>
          {role}
        </Typography>

        <Grid container direction="column" sx={{ mb: 3, gap: 1 }}>
          <Grid container alignItems="center" sx={{ gap: 1 }}>
            <LocalShippingIcon sx={{ fontSize: 16, color: '#0E2465' }} />
            <Typography variant="caption" color="#0E2465" sx={{ fontSize: '12px' }}>
              {serviceCount} {serviceText}
            </Typography>
          </Grid>
          <Grid container alignItems="center" sx={{ gap: 1 }}>
            <FlashOnIcon sx={{ fontSize: 16, color: '#0E2465' }} />
            <Typography variant="caption" color="#0E2465" sx={{ fontSize: '12px' }}>
              4 años en OS
            </Typography>
          </Grid>
        </Grid>

        <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 'auto' }}>
          <Typography variant="caption" sx={{ color: '#A0A3B1', fontSize: '10px' }}>
            +120 Recomendaciones
          </Typography>

          <Button
            variant="contained"
            onClick={handleViewProfile}
            size="small"
            sx={{
              bgcolor: '#0E2465',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              borderRadius: '4px',
              minWidth: 'auto',
              px: 2,
              py: 0.5,
              fontSize: '11px',
              boxShadow: 'none',
              '&:hover': { bgcolor: '#0a1a4a', boxShadow: 'none' }
            }}
          >
            Ver perfil
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ProfileProviderCard;
